import React, { useEffect, useState } from "react";
import "./DashboardPage.css";
import CalendarIcon from "../../assets/icons/calendar-reminder.png";
import { SiTicktick } from "react-icons/si";
import api from "../../services/baseUrl";
import download from "downloadjs";
import { CircularProgress } from "@mui/material";
import Cookies from "js-cookie";
import Modal from "../eGazette/search/Modal";
import { useNavigate } from "react-router-dom";
export default function DashboardPage() {
  console.log("entering dashboard page");
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const userObject = JSON.parse(cookie);
  const packageName = userObject.packageModel.packageName;
  const packageExpiry = userObject.customerUserPackageModel?.expiryDate;
  const date = new Date(packageExpiry);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [fileUUID, setFileUUID] = useState("");
  console.log("1");
  const openModal = async (uuid) => {
    if (uuid) {
      setFileUUID(uuid);
      fetchPdf(uuid);
      setIsModalOpen(true);
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
  };

  console.log("2");
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-GB", options);
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  const result = `Expires on: ${formattedDate} ${formattedTime}`;

  console.log("3");
  const [principalActs, setPrincipalActs] = useState();
  const [amendingActs, setAmendingActs] = useState();
  const [puaActs, setPuaActs] = useState();
  const [pubActs, setPubActs] = useState();
  const [caseLaws, setCaseLaws] = useState();
  const [isLoading, setLoading] = useState(false);
  const [documentId, setDocumentId] = useState("");

  const navigate = useNavigate();

  console.log("4");
  
  useEffect(() => {
    console.log("INSide use effect");
    const fetchData = async () => {
      setLoading(true); // Set loading to true at the start

      try {
        const [
          amendingResponse,
          principalResponse,
          puaResponse,
          pubResponse,
          caseLawResponse,
        ] = await Promise.all([
          api.get("/latestDocuments303"),
          api.get("/latestDocuments301"),
          api.get("/latestDocuments304"),
          api.get("/latestDocuments305"),
          api.get("/latestDocumentsCaseLaw"),
        ]);

        setAmendingActs(amendingResponse.data);
        setPrincipalActs(principalResponse.data);
        setPuaActs(puaResponse.data);
        setPubActs(pubResponse.data);
        setCaseLaws(caseLawResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        
        if(error == "AxiosError: Request failed with status code 401"){
          alert("Your session has expired please login again.");
          navigate("/login");
        } else {
          alert("An error occurred: Please contact the administrator.");
        }
      } finally {
        setLoading(false); // Set loading to false at the end
      }
    };

  console.log("Before fetch data");

    fetchData();
    console.log("after fetch data");
  }, []);

  const downloadPdf = async (uuid, isCaseLaw = false) => {
    try {
      const fileNameEndpoint = isCaseLaw
        ? "/api/caselaw-documents/getFileName"
        : "/document/pdf/getFileName";

      uuid = uuid.replace("caselaw-", "");
      const fileNameResponse = await api.post(
        fileNameEndpoint,
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const fileNameText = await fileNameResponse.data;
      const fileName = fileNameText.split("/").pop();

      const response = await api.post(
        "/document/pdf/download",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      download(response.data, fileName, contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const fetchPdf = async (uuid) => {
    uuid = uuid.replace("caselaw-", "");

    try {
      const response = await api.post(
        "/document/pdf",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const fetchCaseLawPdf = async (documentID) => {
    setDocumentId(documentID);

    try {
      const response = await api.get("/api/caselaw-documents/fileUUID", {
        params: { documentID: documentID },
        headers: {
          "Content-Type": "application/json",
        },
      });

      setFileUUID(`caselaw-${response.data}`);
      openModal(`caselaw-${response.data}`);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const renew = () => {
    const formData = {
      name: userObject.user.fullName,
      packageID: userObject.packageModel.packageCode,
      categoryId: userObject?.customer?.categoryID || 8,
      email: userObject?.user?.email,
      username: userObject?.user?.userName,
    };

    navigate("/payment", { state: formData });
  };
  return (
    <div className="dashboard-container">
      <div className="dashboard-body">
        <div className="dashboard-column-container">
          <div className="dashboard-column">
            <div className="dashboard-icon">
              <img src={CalendarIcon} width={55} alt="" />
            </div>
            <div>
              <h3 className="dashboard-reminder">Reminder!</h3>
              <p className="dashboard-subscription">Current Subscription:</p>
              <p className="dashboard-package">
                {packageName ? packageName : "Package A (Annually)"}
              </p>
              <p className="dashboard-expire">
                {packageExpiry ? result : "Expires on: 21 Aug 2025 12:00 AM"}
              </p>
              {/* <p className="dashboard-expire">({result})</p> */}
            </div>
            <div className="dashboard-renew">
              <button className="dashboard-renew-button">
                <div>
                  <SiTicktick className="dashboard-renew-icon" />
                </div>
                <div
                  onClick={() => {
                    renew();
                  }}
                >
                  <span style={{ fontSize: 13 }}>Renew</span>
                </div>
              </button>
            </div>
          </div>
        </div>
        {/* <Search /> */}
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "5vh",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div>
            <div className="dashboard-act">
              <h1>Principal Act</h1>
              {principalActs?.map((item, index) => (
                <p
                  key={index}
                  onClick={() => openModal(item.documentBlobDto.fileUUID)}
                  style={{ width: "max-content" }}
                >
                  {item.egDocumentDto.actNo} -{" "}
                  {item.egDocumentDto.actTitleBI
                    ? item.egDocumentDto.actTitleBI
                    : item.egDocumentDto.actTitleBM}
                </p>
              ))}
            </div>

            <div className="dashboard-act">
              <h1>Amending Act</h1>
              {amendingActs?.map((item, index) => (
                <p
                  key={index}
                  onClick={() => openModal(item.documentBlobDto.fileUUID)}
                  style={{ width: "max-content" }}
                >
                  {item.egDocumentDto.actNo} -{" "}
                  {item.egDocumentDto.actTitleBI
                    ? item.egDocumentDto.actTitleBI
                    : item.egDocumentDto.actTitleBM}
                </p>
              ))}
            </div>
            <div className="dashboard-act">
              <h1>PUA</h1>
              <ul>
                {puaActs?.map((item, index) => (
                  <p
                    key={index}
                    onClick={() => openModal(item.documentBlobDto.fileUUID)}
                    className="dashboard-gazette"
                  >
                    {item.egDocumentDto.actNo}
                    {item.egDocumentDto.actTitleBI ? (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.egDocumentDto.actTitleBI,
                        }}
                      ></p>
                    ) : (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.egDocumentDto.actTitleBM,
                        }}
                      ></p>
                    )}
                  </p>
                ))}
              </ul>
            </div>
            <div className="dashboard-act">
              <h1>PUB</h1>
              <ul>
                {pubActs?.map((item, index) => (
                  <p
                    key={index}
                    onClick={() => openModal(item.documentBlobDto.fileUUID)}
                    className="dashboard-gazette"
                  >
                    {item.egDocumentDto.actNo}
                    {item.egDocumentDto.actTitleBI ? (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.egDocumentDto.actTitleBI,
                        }}
                      ></p>
                    ) : (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item.egDocumentDto.actTitleBM,
                        }}
                      ></p>
                    )}
                  </p>
                ))}
              </ul>
            </div>
            <div className="dashboard-act">
              <h1>Case Law</h1>
              {caseLaws?.map((item, index) => (
                <p
                  style={{ width: "max-content" }}
                  onClick={() => {
                    fetchCaseLawPdf(item.documentID);
                  }}
                >
                  <span key={item.documentID}>{item.caseNo}</span>
                  <br />
                  <span style={{ width: "max-content" }}>{item.caseTitle}</span>
                  <div style={{ height: "10px" }}></div>
                </p>
              ))}
            </div>
          </div>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        keyword={""}
        pdf={file}
        pageNumber={1}
        fileUUID={fileUUID}
        downloadPdf={(uuid) => downloadPdf(uuid, fileUUID.includes("caselaw"))}
        documentId={documentId}
      />
    </div>
  );
}
